export default class QueryRelation1N
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryRelation1N";

	static OneToMany = "OneToMany";
	static ManyToOne = "ManyToOne";
		
	static OneToManyLabel = "OneToMany";
	static OneToManyNotLabel = "OneToMany(NOT)";
	static ManyToOneLabel = "ManyToOne";
		
	static valueOf(value)
	{
		if(value == QueryRelation1N.OneToManyLabel || value == QueryRelation1N.OneToManyNotLabel)
			return QueryRelation1N.OneToMany;
		else if(value == QueryRelation1N.ManyToOneLabel)
			return QueryRelation1N.ManyToOne;
		
		throw new Error("类型非法");
	}
	
	static labelOf(value)
	{
		if(value == QueryRelation1N.OneToMany)
			return QueryRelation1N.OneToManyLabel;
		else if(value == QueryRelation1N.ManyToOne)
			return QueryRelation1N.ManyToOneLabel;
		
		throw new Error("类型非法");
	}
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryRelation1N.js